import { Expose } from 'class-transformer';

export class ModelPromotion {
    @Expose()
    title: string;

    @Expose()
    text: string;

    @Expose()
    image: string;

    @Expose()
    btnLink: string;
}
